import React from "react";
function NewFooter() {
    return (
        <div data-scroll-section>

<div  data-scroll=''  data-scroll-repeat='true'  data-scroll-class='se'  class='fi' >

</div>

        </div>
       
    );
  }
  
  export default NewFooter;
  